import { ToggleGroup, ToggleGroupItem } from "@workspace/frontend-ui";
import type { FC } from "react";

type Props = {
  category: string;
  enabledCategories: string[];
  categoryLabels: Record<string, string>;
  onCategoryChange: (category: string) => void;
};

const CategoryToggles: FC<Props> = ({
  category,
  enabledCategories,
  categoryLabels,
  onCategoryChange,
}) => (
  <div className="w-full overflow-x-auto">
    <ToggleGroup
      type="single"
      value={category}
      onValueChange={(val: string) => val && onCategoryChange(val)}
      spacing={2}
    >
      {enabledCategories.map((value) => (
        <ToggleGroupItem
          size="xl"
          key={value}
          value={value}
          className="border border-transparent bg-secondary rounded-full data-[state=on]:bg-transparent! data-[state=on]:border-(--primary)! data-[state=on]:text-primary data-[state=on]:focus-visible:border-(--primary)!"
        >
          {categoryLabels[value]}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  </div>
);

export default CategoryToggles;
